import React from 'react'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'

// const OtherComponent =
//   process.env.NODE_ENV === 'dev'
//     ? React.lazy(
//         async () =>
//           await import('@tanstack/react-query-devtools').then(module => ({ default: module.ReactQueryDevtools }))
//       )
//     : () => <></>

interface ICacheProviderProps {
  children: React.ReactNode
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: false }
  }
})

const CacheProvider = ({ children }: ICacheProviderProps): JSX.Element => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* <OtherComponent initialIsOpen={false} /> */}
    </QueryClientProvider>
  )
}

export { CacheProvider, queryClient }
